import { PaginatedDataDTO } from '@bottega52/commons-pagination';
import { Button, createStyles, WithStyles } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import { withStyles } from '@material-ui/styles';
import _ from 'lodash';
import 'moment/locale/it';
import qs from 'query-string';
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ModalTypes } from '../../components/Modals/ModalTypes';
import ReduxLanguage from '../../components/ReduxLanguage';
import * as CreditsActions from '../../redux/credits/credits.actions';
import * as ModalsActions from '../../redux/modals/modals.actions';
import CustomerContractDetailsView from "../../components/Customers/CustomerContractDetailsView";
import * as SettingsActions from '../../redux/settings/settings.actions';
import { IState } from '../../redux/store';
import { ICustomerContractServicesRequestParamsDTO } from '../../repository/jago/model/output/RequestParamsDTOs';
import AbilityProvider from '../../services/PermissionService/AbilityProvider';
import { PERMISSIONS } from '../../services/PermissionService/PermissionConstants';
import translations from '../../translations/i18next';
import { ICustomerContractInDTO } from '../../repository/jago/model/input/ICustomerContractInDTO';
import { ICustomerContractServiceInDTO } from '../../repository/jago/model/input/ICustomerContractServiceInDTO';
import { ICustomerContractServiceSearchDTO } from '../../repository/jago/model/input/ICustomerContractServiceSearchDTO';
import CustomerContractServicesSearchBar from '../../components/SearchBar/CustomerContractServicesSearchBar';
import moment from 'moment';
import CustomerContractServicesTable from '../../components/Customers/CustomerContractServicesTable';

const styles = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
  },
  text: {
    margin: 0,
    marginBottom: 15,
  },
  innerHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    zIndex: 200,
    padding: 10,
    paddingRight: 20,
    borderBottom: '2px solid #5AC0B1',
  },
  tableContainer: {
    display: 'flex',
    backgroundColor: 'white',
    height: 'calc(100vh - 160px)',
    width: '100%'
  },
});
export interface ICustomerContractServicesPageState {
  rowsPerPage: number;
  isLoading: boolean;
  filters: ICustomerContractServiceSearchDTO;
}

type IReduxProps = ConnectedProps<typeof connector> & RouteComponentProps<any>;

export interface ICustomerContractServicesPageProps extends WithStyles<typeof styles> {
  language: string;
  customerContracts: PaginatedDataDTO<ICustomerContractInDTO>;
}

export type ComponentProps = ICustomerContractServicesPageProps & IReduxProps;

class CustomerContractServicesPage extends React.Component<ComponentProps, ICustomerContractServicesPageState> {
  
  constructor(props: ComponentProps) {
    super(props);
    this.state = {
      isLoading: false,
      rowsPerPage: 50,
      filters: {
        search: '',
      }
    }
  }

  public async componentDidMount() {
    const { dispatch, history } = this.props;
    const { rowsPerPage } = this.state;
    const parsed = qs.parse(history.location.search);
    this.setState({ isLoading: true });
    try {
      await dispatch<any>(CreditsActions.fetchAllCustomerContractServices({ page: 0, pageSize: rowsPerPage }));
      this.setState({ isLoading: false });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  }

  async onFetchCustomerContractServices(page: number = 0, pageSize: number = 100) {
    const { dispatch } = this.props;
    const { filters } = this.state;
    try {
      const params: ICustomerContractServicesRequestParamsDTO = { page, pageSize, ...filters };
      this.setState({ isLoading: true });
      await dispatch<any>(CreditsActions.fetchAllCustomerContractServices(params));
      this.setState({ isLoading: false });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  }

  public onDeleteCustomerContractRequest(customerContractData: ICustomerContractInDTO) {
    const { dispatch } = this.props;
    dispatch<any>(ModalsActions.showModal(`DELETE_CUSTOMER_CONTRACT_CONFIRM_MODAL`, {
      modalType: ModalTypes.CONFIRM_MODAL,
      modalProps: {
        icon: <WarningIcon style={{ color: 'orange', fontSize: 50 }} />,
        titleMessageKey: 'credits.deleteCustomerContract',
        successMessageKey: 'credits.deleteCustomerContractConfirm',
        confirmMessageKey: 'forms.confirm',
        cancelMessageKey: 'forms.cancel',
        onConfirm: () => this.onDeleteCustomerContractConfirm(customerContractData),
        onCancel: () => dispatch<any>(ModalsActions.hideModal(`DELETE_CUSTOMER_CONTRACT_CONFIRM_MODAL`)),
      }
    }));
  }

  public async onDeleteCustomerContractConfirm(customerContractData: ICustomerContractInDTO) {
    const { dispatch, selectedCustomer } = this.props;
    const { rowsPerPage } = this.state;
    try {
      dispatch<any>(ModalsActions.hideModal(`DELETE_CUSTOMER_CONTRACT_CONFIRM_MODAL`));
      dispatch<any>(SettingsActions.setSpinnerVisible(true));
      await dispatch<any>(CreditsActions.deleteCustomerContract(selectedCustomer.id, customerContractData.id));
      await dispatch<any>(CreditsActions.setSelectedCustomerContract({}));
      dispatch<any>(ModalsActions.hideModal('OPERATIONAL_CUSTOMER_CONTRACT_MODAL'));
      await this.onFetchCustomerContractServices(0, rowsPerPage);
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      await dispatch<any>(CreditsActions.setSelectedCustomerContract({}));
      dispatch<any>(ModalsActions.hideModal('OPERATIONAL_CUSTOMER_CONTRACT_MODAL'));
      dispatch<any>(ModalsActions.showModal(`ERROR_CUSTOMER_CONTRACT_CREATION`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'credits.deleteCustomerContractError',
        }
      }));
    }
  }

  public async onRowClick(customerContractService: ICustomerContractServiceInDTO) {
    const { dispatch } = this.props;
    try {
      dispatch<any>(SettingsActions.setSpinnerVisible(true));
      const customer = await dispatch<any>(CreditsActions.fetchCustomerDetails(customerContractService.customerId));
      await dispatch<any>(CreditsActions.setSelecteCustomer(customer));
      const customerContract = await dispatch<any>(CreditsActions.fetchCustomerContractDetails(customer.id, customerContractService.customerContractId));
      await dispatch<any>(CreditsActions.setSelectedCustomerContract(customerContract));
      if (AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.CONTRACT_SERVICES_READ)) {
        await dispatch<any>(CreditsActions.fetchCustomerContractServices({pageSize: 200, customerId: customer.id, contractId: customerContract.id }));
      }
      if (AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.CUSTOMER_PLANTS_READ)) {
        await dispatch<any>(CreditsActions.fetchCustomerPlants({pageSize: 200, customerId: customer.id }));
      }
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`OPERATIONAL_CUSTOMER_CONTRACT_MODAL`, {
        modalType: ModalTypes.OPERATIONAL_VIEW_MODAL,
        modalProps: {
          onClose: () => dispatch<any>(CreditsActions.setSelectedCustomerContract({})),
          overflowDisabled: true,
          content: (
            <CustomerContractDetailsView
              onDeleteCustomerContractRequest={(customerContract) => {this.onDeleteCustomerContractRequest(customerContract)}}
              initialTab={1}
            />
          ),
          titleMessageKey: 'credits.customerContractDetails',
        }
      }));
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`ERROR_CUSTOMER_CONTRACT_DETAILS`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'errors.getCustomerContractDetailsError',
        }
      }));
    }
  }

  exportCSV() {
    const { dispatch } = this.props;
    const { filters } = this.state;
    dispatch<any>(SettingsActions.setSpinnerVisible(true));
    try {
      dispatch<any>(CreditsActions.fetchAllCustomerContractServices({ page: 0, pageSize: 10000, doNotSave: true, enrichWithVar: true, enrichWithPlantName: true, ...filters }))
        .then(async (response: any) => {
          if (response && response.content) {
            const exportData: any[] = [];
            _.map(response.content, service => {
              const totalInvoiced = service.netPrice != null && service.quantity != null
                ? service.netPrice * service.quantity
                : '---';
              exportData.push({
                'Service Code': service.code || '---',
                'Quantity': service.quantity != null ? service.quantity : '---',
                'Net Price': service.netPrice != null ? service.netPrice : '---',
                'Original Price': service.originalPrice != null ? service.originalPrice : '---',
                'Total Invoiced': totalInvoiced,
                'Subject': service.subject || '---',
                'Type': service.type || '---',
                'Group Family': service.groupFamily || '---',
                'Status': service.status ? translations.t(`credits.customerContractServiceStatus_${service.status}`).toUpperCase() : '---',
                'Activation Date': service.activationDate ? moment(service.activationDate).format('DD/MM/YYYY') : '---',
                'Deactivation Date': service.deactivationDate ? moment(service.deactivationDate).format('DD/MM/YYYY') : '---',
                'Customer ID': service.customerId || '---',
                'Customer Name': service.customerName || '---',
                'VAR': service.varName || '---',
                'Plant Name': service.plants && service.plants.length > 0 ? service.plants.map(p => p.name).join(', ') : '---',
                'Contract ID': service.customerContractId || '---',
                'Contract Name': service.customerContractName || '---',
                'PO Number': service.sellOutPONumber || '---',
                'SFDC ID': service.sfdcId || '---',
                'Notes': service.notes || '---'
              });
            });
            const csvContent = "data:text/csv;charset=utf-8,"
              + "Service Code,Quantity,Net Price,Original Price,Total Invoiced,Subject,Type,Group Family,Status,Activation Date,Deactivation Date,Customer ID,Customer Name,VAR,Plant Name,Contract ID,Contract Name,PO Number,SFDC ID,Notes\n"
              + exportData.map(row =>
                  `"${row['Service Code']}","${row['Quantity']}","${row['Net Price']}","${row['Original Price']}","${row['Total Invoiced']}","${row['Subject']}","${row['Type']}","${row['Group Family']}","${row['Status']}","${row['Activation Date']}","${row['Deactivation Date']}","${row['Customer ID']}","${row['Customer Name']}","${row['VAR']}","${row['Plant Name']}","${row['Contract ID']}","${row['Contract Name']}","${row['PO Number']}","${row['SFDC ID']}","${row['Notes']}"`
                ).join("\n");
            const encodedUri = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", `customer-contract-services-${moment().toISOString()}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          dispatch<any>(SettingsActions.setSpinnerVisible(false));
        })
        .catch(error => {
          dispatch<any>(SettingsActions.setSpinnerVisible(false));
          dispatch<any>(ModalsActions.showModal(`ERROR_CUSTOMER_CONTRACT_SERVICES_EXPORT`, {
            modalType: ModalTypes.ERROR_MODAL,
            modalProps: {
              titleMessageKey: 'errors.error',
              errorMessageKey: 'errors.exportCustomerContractServicesError',
            }
          }));
        });
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`ERROR_CUSTOMER_CONTRACT_SERVICES_EXPORT`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'errors.exportCustomerContractServicesError',
        }
      }));
    }
  }

  public async handleChangeRowsPerPage(pageSize: number) {
    this.setState({ rowsPerPage: pageSize, isLoading: true }, async () => {
      this.onFetchCustomerContractServices(0, pageSize);
    });
  }

  onSearchCustomerContractServices(searchValues: ICustomerContractServiceSearchDTO) {
    const { rowsPerPage } = this.state;
    const formattedFilters = _.omitBy(searchValues, filter => filter === '' || filter === null);
    this.setState({ filters: { ...formattedFilters } }, async () => {
      this.onFetchCustomerContractServices(0, rowsPerPage);
    });
    
  }

  onResetSearch() {
    const { dispatch } = this.props;
    const { rowsPerPage } = this.state;
    this.setState({
      filters: {
        search: '',
        status: undefined,
      },
    }, async () => {
      await this.onFetchCustomerContractServices(0, rowsPerPage);
      dispatch<any>(CreditsActions.fetchAllCustomerContractServices({ page: 0, pageSize: 10000 }))
    })
  }

  onCustomerClick(customerId: number) {
    const { history } = this.props
    history.push(`/customers?customerId=${customerId}`);
  }

  onContractClick(contractId: number) {
    const { history } = this.props
    history.push(`/contracts?contractId=${contractId}`);
  }

  render() {
    const { rowsPerPage } = this.state;
    const { classes, customerContractServices } = this.props;

    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <CustomerContractServicesSearchBar 
            onSearch={(values: ICustomerContractServiceSearchDTO) => this.onSearchCustomerContractServices(values)}
            onResetSearch={() => this.onResetSearch()}
          />
          <div style={{ display: 'flex', flexDirection: 'row'}}>
            <Button
              variant="contained"
              style={{ backgroundColor: 'cornflowerblue', color: 'white', fontSize: 10, marginLeft: 10, fontWeight: 'bold'  }}
              onClick={() => this.exportCSV()}
            >
              <ReduxLanguage languageKey="credits.exportCustomerContractsCSV" />
            </Button>
          </div>
        </div>
        <div className={classes.tableContainer}>
        <CustomerContractServicesTable
          rowsPerPage={rowsPerPage}
          customerContractServices={customerContractServices as PaginatedDataDTO<ICustomerContractServiceInDTO>}
          onRowClick={(customerContractService) => {this.onRowClick(customerContractService)}}
          onPageSizeChange={pageSize => this.handleChangeRowsPerPage(pageSize)}
          onFetchElementsOnPage={page => this.onFetchCustomerContractServices(page, rowsPerPage)}
          onDeleteCustomerContractServiceRequest={() => {}}
          showCustomer={true}
          hideDeleteButton={true}
          onCustomerClick={(customerId: number) => this.onCustomerClick(customerId)}
          onContractClick={(contractId: number) => this.onContractClick(contractId)}
        />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: IState) {
  return {
    language: state.settings.language,
    selectedCustomer: state.credits.customers.selectedDetailedCustomer,
    customerContracts: state.credits.allCustomerContracts.data,
    customerContractServices: state.credits.allCustomerContractServices.data,
    allCustomers: state.credits.allCustomers.data,
  };
}

const connector = connect(mapStateToProps);

export default connector(withRouter(withStyles(styles)(CustomerContractServicesPage)));